import LineAndBarChartViz from '../vizs/LineAndBarChartViz'
import BaseComponent from './BaseComponent'
/**
 * # {componentLabel} (`class {componentClassName}`)
 * Used to display data using a number of bars and/or lines, each of which represent a particular category. A combination of bars and lines in the same visualization can be useful when comparing values in different categories, since the combination gives a clear view of which category is higher or lower. An example of this can be seen when comparing the projected sales with the actual sales for different time periods.
 * 
 * ### Example Usage
 * ```javascript
 *   
 *   import {LineAndBarChart} from 'sdv-lib'
 *   
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new LineAndBarChart($el, data, config);
 *   
 * ```
 * 
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 3 or more columns. 
 * 
 * Each row represents a point in the X axis. The first column should be the id/label of each point. 
 * 
 * The second column represents the values for the Bars in the chart.
 * 
 * The rest of the columns should represent the values for each of the lines in the chart.
 * 
 * |  categroy    | bar  |  line1   |  line2   |
 * | --------   | ------ |  ------  |  ------  |
 * |   a       |    22.4|      15.4|      43.2|
 * |   b      |    52.3|      29.3|      12.8|
 * |   c      |    12.8|      34.1|      61.4|
 * |   d      |    26.0|      12.3|      14.5|
 * 
 * {.data-table}
 * */
export default class LineAndBarChartComponent extends BaseComponent {
  static vizClass = LineAndBarChartViz
  static componentLabel = "Bar + Line chart"
  static dataFormat = [
    {index:0, axis:'x0', types:[String], role:'id', roleLabel:'Category (X)'},
    {index:1, axis:'y0', types:[Number], role:'value', roleLabel:'Bar value (Y)'},
    {index:-1, axis:'y0', label:'Line', types:[Number],role:'value',roleLabel: 'Line value (Y)'}
  ]
  static defaultConfig = {
    title: this.componentLabel,
    AxisHelper: {
      x:{
        /**
         * Show/hide labels for each bar on the X axis.
         */
        showTickValues: false,
      }
    }
  }
}
